export const menusSelector = state => state.menus;